import { BsFileEarmarkPostFill, BsGlobe, BsSearch } from "react-icons/bs";

export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const HOME_DATA = [
  {
    title: "Create Stunning Blogs",
    description:
      "Craft visually appealing and engaging blogs using our intuitive and user-friendly editor. Express yourself with rich formatting options, images, videos, and more.",
    icon: BsFileEarmarkPostFill,
  },
  {
    title: "Reach a Global Audience",
    description:
      "Share your stories, ideas, and insights with a worldwide audience. Connect with readers from different backgrounds and cultures who are eager to discover your content.",
    icon: BsGlobe,
  },
  {
    title: "Enhance Your Online Presence",
    description:
      "Whether you're a seasoned Blogshog or just starting out, Blogshog helps you establish your online identity. Build your personal brand and become a trusted voice in your niche.",
    icon: BsSearch,
  },
];

export const FEATURED_IMAGE =
  "https://images.pexels.com/photos/262508/pexels-photo-262508.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1";
